import { actionTypes } from '../actions';
const initState = {};

function user(state = initState, action) {
  switch (action.type) {
    case actionTypes.SET_USER:
      // Make sure we aren't accidently setting user password into store
      if (action.user && action.user.password) delete action.user.password;

      if (action.overwrite) {
        return action.user;
      }
      // only update keys provided
      return { ...state, ...action.user };

    case actionTypes.LOGOUT_USER:
      return {};

    default:
      return state;
  }
}

export default user;


// WEBPACK FOOTER //
// ./src/reducers/user.js